export default "__VITE_ASSET__C82rKoKx__"